<template>
  <v-row justify="center">
    <v-dialog
      persistent
      v-model="showDialogComp"
      scrollable
      max-width="700"
      @click:outside="cancel"
    >
      <v-card>
        <v-card-title>
          Add Media to galleries
          <v-btn absolute right v-on:click="done">done</v-btn>
        </v-card-title>
        <!--        <v-divider></v-divider>-->

        <!--        <v-divider></v-divider>-->

        <!--        <div class="d-inline-block pa-2">-->
        <!--          <v-chip-->
        <!--            v-for="pg in $store.state.MediaStore-->
        <!--              .selectedMediaItemParentGalleries"-->
        <!--            :key="pg.id"-->
        <!--            close-->
        <!--            @click:close="removeFromGallery(pg.id)"-->
        <!--            class="ma-2"-->
        <!--            >{{ pg.name }}</v-chip-->
        <!--          >-->
        <!--        </div>-->

        <!--        <v-divider></v-divider>-->
        <!--        <br />-->
        <v-card>
          <!-- <v-card-title>
            Galleries
            <v-btn absolute right v-on:click="add">add</v-btn>
          </v-card-title>-->
          <!-- <v-select
            v-model="selectedGallery"
            :items="$store.state.MediaStore.galleries"
            label="Choose gallery"
            outlined
          >
            <template slot="item" slot-scope="data">{{ data.item.name }}</template>
            <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
          </v-select>-->
          <v-autocomplete
            v-model="selectedGalleriesComp"
            :disabled="isUpdating"
            :items="allAvailableGalleries"
            filled
            chips
            color="blue-grey lighten-2"
            label="Select"
            item-text="name"
            item-value="id"
            multiple
            hide-selected
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="remove(data.item)"
                >{{ data.item.name }}</v-chip
              >
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content
                  v-text="data.item"
                  v-on:click="add"
                ></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.name"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="data.item.group"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
        </v-card>
        <!-- <v-card-actions>
          <v-btn v-on:click="cancel">cancel</v-btn>
          <v-btn v-on:click="done">done</v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      name: 'Add to gallery',
      show: false,
      selectedGallery: {},
      selectedGalleries: [],
      isUpdating: false
    }
  },
  computed: {
    showDialogComp: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        this.show = newValue
      }
    },
    allAvailableGalleries: function() {
      return this.$store.state.MediaStore.mediaContextGalleries
      // return this.$store.state.MediaStore.selectedMediaItemOtherGalleries.concat(
      //   this.$store.state.MediaStore.selectedMediaItemParentGalleries
      // )
    },
    selectedGalleriesComp: {
      get: function() {
        return this.$store.state.MediaStore.selectedMediaItemParentGalleries
      },
      set: function(newVal) {
        let galleryAdded = []
        let galleryRemoved = []
        //gallery added by user
        newVal.forEach(item => {
          if (this.selectedGalleries.indexOf(item) === -1) {
            galleryAdded.push(item)
          }
        })
        //gallery removed by user
        this.selectedGalleries.forEach(item => {
          if (newVal.indexOf(item) === -1) {
            galleryRemoved.push(item)
          }
        })

        this.selectedGalleries = newVal
        // if (galleryAdded.length>0) {
        //   this.add()
        // } else if (galleryRemoved.length>0) {
        //   galleryRemoved.forEach(item=>{
        //     this.removeFromGallery(item)
        //   })
        // }
        this.add()
      }
    }
  },
  beforeMount() {},
  mounted() {},
  created: function() {
    this.showDialogComp = this.showDialog
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    selectedGalleries(newVal, oldVal) {}
  },
  methods: {
    cancel: function() {
      this.$emit('cancel')
    },
    add: function() {
      this.$store.dispatch(
        'MediaStore/addToMultipleGalleries',
        {
          mediaId: this.$store.state.MediaStore.selectedMediaItem.id,
          galleryIds: this.selectedGalleries
        },
        {
          root: true
        }
      )
    },
    remove(item) {
      const index = this.selectedGalleriesComp.indexOf(item.id)
      if (index >= 0) {
        this.selectedGalleries = this.selectedGalleries.splice(index, 1)
      }
      this.removeFromGallery(item.id)
    },
    removeFromGallery: function(id) {
      console.log('removeFromGallery', {
        galleryId: id,
        mediaId: this.$store.state.MediaStore.selectedMediaItem.id
      })
      this.$store.dispatch(
        'MediaStore/removeFromGallery',
        {
          galleryId: id,
          mediaId: this.$store.state.MediaStore.selectedMediaItem.id
        },
        {
          root: true
        }
      )
    },
    done: function() {
      this.$emit('done')
    }
  }
}
</script>

<style scoped></style>
